<div class="row">
  <div class="col-md-12">
    <br>
    <div class="titulo">
        Mantenedor de Tips Login
    </div>
  </div>

  <div class="col-md-12">
    <br>
    <div class="sub-titulo">

      <div class="sub-titulo d-flex align-items-center justify-content-between">
        <span class="linea">
          Listado de Tips Login
        </span>

        <div class="d-flex align-items-center">
          <!-- Selector de clientes -->
          <select
            class="form-control mr-2"
            style="min-width: 260px;"
            [(ngModel)]="selectedCustomerId"
            (ngModelChange)="applyFilter()"
          >
            <option [ngValue]="null">Todos los clientes</option>
            <option *ngFor="let c of listCustomers" [ngValue]="c.cus_id">
              {{ c.cus_name }}
            </option>
          </select>


          <!-- Botón -->
          <button
            type="button"
            class="btn btn-outline-primary botonListar"
            data-toggle="modal"
            data-target="#crearTipsLogin"
          >
            Agregar Tip Login
          </button>
        </div>
      </div>
      
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center my-4">
    <div class="loader">
      <div class="loader__figure"></div>
      <p class="loader__label">Medis</p>
    </div>
  </div>

  <div *ngIf="isLoading == false" class="col-md-12">
    <br>
    <table class="table table-bordered">
      <thead style="font-family: Mulish; font-style: normal; font-weight: bold; font-size: 20px; color: #171994; text-align: center; background-color: #e6f0ff;">
        <tr>
          <th>#</th>
          <th>Cliente</th>
          <th>Descripción</th>
          <th>Fecha de Creación</th>
          <th>Fecha de Vencimiento</th>
          <th>Es Global</th>
          <th>Estado</th>
          <th>Editar</th>
        </tr>
      </thead>
      <tbody style="background-color: white; font-family: Mulish; font-size: 16px; color: #3F3F3F; text-align: center;">
        <tr class="ng-star-inserted" *ngIf="tipsFiltered.length == 0">
          <td colspan="6">No se encontraron registros</td>
        </tr>
        <tr class="ng-star-inserted" *ngFor="let tips of tipsFiltered">
          <td>{{tips.con_info_id}}</td>
          <td>{{tips.cus_name ? tips.cus_name : 'Global'}}</td>
          <td>{{tips.con_info_description}}</td>
          <td>{{tips.desdeFormat }}</td>
          <td>{{tips.hastaFormat }}</td>
          <td>{{tips.is_global ? 'Si' : 'No' }}</td>
          <td>{{tips.estado}}</td>
          <td>
            <div class="row justify-content-center m-0">
              <div class="col-12 p-0">
                <span data-toggle="modal" data-target="#visualizarTipsLogin" style="cursor: pointer;" (click)="clickTipsLogin(tips)">
                  <mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" 
                      style="color: #316AD8;" aria-hidden="true" data-mat-icon-type="font">manage_search
                  </mat-icon>
                </span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  
  <div *ngIf="isLoading" class="overlay-cargando">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>


</div>

<!-- modal Ver/Editar Tip Login -->
<div class="modal fade" id="visualizarTipsLogin" aria-labelledby="exampleModalLabel" aria-hidden="true" #visualizarTipsLogin>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%;width: auto;">Ver / Editar Tip Login</p>
          <hr class="estiloHrModal">
          <br>

          <div class="divBodyModal row">

            <!-- Título -->
            <div class="col-12 col-md-8">
              <p class="letraNormalModal"><strong>Título:</strong></p>
              <input
                class="form-control camposModalAgregar"
                type="text"
                placeholder="Título"
                [(ngModel)]="tipSelected.con_info_title"
                [disabled]="!isEdit"
                [ngClass]="{'is-invalid': errores['con_info_title']}"
                maxlength="50"
                (input)="tipSelected.con_info_title = (tipSelected.con_info_title || '').slice(0, 50)"
              >
              <small class="text-muted">
                {{ (tipSelected.con_info_title?.length || 0) }} / 50
              </small>
              <div *ngIf="errores['con_info_title']" class="invalid-feedback">
                El título es obligatorio.
              </div>
            </div>

            <!-- Orden / Prioridad -->
            <div class="col-12 col-md-4">
              <p class="letraNormalModal"><strong>Orden / Prioridad:</strong></p>
              <select
                class="form-control"
                [(ngModel)]="tipSelected.con_info_priority"
                [disabled]="!isEdit"
              >
                <option *ngFor="let num of numeros" [value]="num">{{ num }}</option>
              </select>
              <small class="text-muted">Menor prioridad = aparece primero.</small>
            </div>

            <!-- Descripción -->
            <div class="col-12 mt-3">
              <p class="letraNormalModal"><strong>Descripción:</strong></p>
              <textarea
                class="form-control camposModalAgregar"
                placeholder="Descripción"
                [(ngModel)]="tipSelected.con_info_description"
                [disabled]="!isEdit"
                [ngClass]="{'is-invalid': errores['con_info_description']}"
                rows="2"
                maxlength="70"
                minlength="45"
                (input)="tipSelected.con_info_description = (tipSelected.con_info_description || '').slice(0, 150)"
              ></textarea>
              <small class="text-muted">
                {{ (tipSelected.con_info_description?.length || 0) }} / 70
              </small>
              <div *ngIf="errores['con_info_description']" class="invalid-feedback">
                La descripción es obligatoria.
              </div>
            </div>

            <!-- Fechas -->
            <div class="col-6 mt-3">
              <p class="letraNormalModal"><strong>Fecha desde:</strong></p>
              <input
                type="date"
                [(ngModel)]="tipSelected.con_info_date_from2"
                class="form-control"
                [disabled]="!isEdit"
              />
            </div>

            <div class="col-6 mt-3">
              <p class="letraNormalModal"><strong>Fecha hasta:</strong></p>
              <input
                type="date"
                [(ngModel)]="tipSelected.con_info_date_to2"
                class="form-control"
                [disabled]="!isEdit"
              />
            </div>

            <!-- Check habilitado -->
            <div class="col-4 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkTipStatus"
                  [(ngModel)]="tipSelected.status"
                  [disabled]="!isEdit"
                >
                <label class="custom-control-label letraNormalModal" for="chkTipStatus">
                  <strong>Habilitado</strong>
                </label>
              </div>
            </div>

            <div class="col-4 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkEditGlobalAuspicio"
                  [(ngModel)]="tipSelected.is_global"
                  [disabled]="!isEdit"
                  (change)="tipSelected.is_global ? (tipSelected.client_id = null) : null"
                >
                <label class="custom-control-label letraNormalModal" for="chkEditGlobalAuspicio">
                  <strong>Global (para todos los clientes)</strong>
                </label>
              </div>
            </div>

            <!-- Cliente -->
            <div class="col-12 mt-2">
              <p class="letraNormalModal"><strong>Cliente:</strong></p>
              <select
                class="form-control"
                [(ngModel)]="tipSelected.con_info_cus_id"
                [disabled]="tipSelected.is_global || !isEdit"
                [ngClass]="{'is-invalid': errores.client_id}"
              >
                <option [ngValue]="null">Seleccione cliente...</option>
                <option *ngFor="let c of listCustomers" [ngValue]="c.cus_id">
                  {{ c.cus_name }}
                </option>
              </select>

              <div *ngIf="errores.client_id" class="invalid-feedback">
                Debes seleccionar un cliente si el auspicio no es global.
              </div>

              <small *ngIf="tipSelected.is_global" class="text-muted">
                Al ser global, no se asocia a un cliente específico.
              </small>
            </div>

          </div>

          <hr class="estiloHrModal">

          <!-- Botones -->
          <div class="container-fluid" style="padding: 10px 10px;align-items:center;text-align: center;">

            <!-- modo ver -->
            <button
              *ngIf="!isEdit"
              type="button"
              class="primary buttonStyleSecondary"
              (click)="editTip()"
              [disabled]="isLoading"
            >
              Editar
            </button>

            <!-- modo editar -->
            <button
              *ngIf="isEdit"
              type="button"
              class="primary buttonStyleSecondary"
              (click)="updateTip()"
              [disabled]="isLoading"
            >
              <span *ngIf="!isLoading">Guardar cambios</span>
              <span *ngIf="isLoading">Guardando...</span>
            </button>

            <button
              type="button"
              class="boton-accion colorLetraVolver ml-2"
              data-dismiss="modal"
              aria-label="Close"
              [disabled]="isLoading"
              (click)="cancelEditTip()"
            >
              Cerrar
            </button>

          </div>

        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading && modalActivo === 'editar'" class="overlay-modal">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>
</div>
<!-- /modal Ver/Editar Tip Login -->



<!-- modal Guardar-->
<div class="modal fade" id="crearTipsLogin" aria-labelledby="exampleModalLabel" aria-hidden="true"
    #crearTipsLogin>
  <div class="modal-dialog modal-lg">
    <div class="modal-content" >
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%;width: auto;">Crear nuevo Tips</p>
          <hr class="estiloHrModal">
          <br>
          <div class="divBodyModal row">
            <div class="col-6">
              <p class="letraNormalModal"><strong>Título:</strong></p>
              <input
                class="form-control camposModalAgregar"
                type="text"
                placeholder="Título"
                [(ngModel)]="nuevoTip.titulo"
                [ngClass]="{'is-invalid': errores.titulo}"
                maxlength="50"
                (input)="nuevoTip.titulo = (nuevoTip.titulo || '').slice(0, 50)"
              >
              <small class="text-muted">
                {{ (nuevoTip.titulo?.length || 0) }} / 50
              </small>
              <div *ngIf="errores.titulo" class="invalid-feedback">
                El título es obligatorio.
              </div>
            </div>

            <div class="col-6 mt-6">
              <p class="letraNormalModal"><strong>Orden de aparición:</strong></p>
              <select class="form-control" [(ngModel)]="nuevoTip.numero">
                <option *ngFor="let num of numeros" [value]="num">{{ num }}</option>
              </select>
            </div>

            <div class="col-9 mt-3">
              <p class="letraNormalModal"><strong>Descripción:</strong></p>
              <textarea
                class="form-control camposModalAgregar"
                placeholder="Descripción"
                [(ngModel)]="nuevoTip.descripcion"
                [ngClass]="{'is-invalid': errores.descripcion}"
                rows="3"
                maxlength="70"
                minlength="45"
                (input)="nuevoTip.descripcion = (nuevoTip.descripcion || '').slice(0, 150)"
              ></textarea>
              <small class="text-muted">
                {{ (nuevoTip.descripcion?.length || 0) }} / 70
              </small>
              <div *ngIf="errores.descripcion" class="invalid-feedback">
                La descripción es obligatoria.
              </div>
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Fecha de Creación:</strong> </p>
              <input type="date" [(ngModel)]="nuevoTip.fechaFrom" class="form-control" />
            </div>
            <div class="col-6">
              <p class="letraNormalModal"><strong>Fecha de Vencimiento:</strong> </p>
              <input type="date" [(ngModel)]="nuevoTip.fechaTo" class="form-control" />
            </div>
          </div>

          <!-- Global + Cliente -->
            <div class="col-4 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkGlobalAuspicio"
                  [(ngModel)]="nuevoTip.is_global"
                  (change)="nuevoTip.is_global ? (nuevoTip.client_id = null) : null"
                >
                <label class="custom-control-label letraNormalModal" for="chkGlobalAuspicio">
                  <strong>Global (para todos los clientes)</strong>
                </label>
              </div>
            </div>

            <div class="col-12 mt-2">
              <p class="letraNormalModal"><strong>Cliente:</strong></p>
              <select
                class="form-control"
                [(ngModel)]="nuevoTip.client_id"
                [disabled]="nuevoTip.is_global"
                [ngClass]="{'is-invalid': errores.client_id}"
              >
                <option [ngValue]="null">Seleccione cliente...</option>
                <option *ngFor="let c of listCustomers" [ngValue]="c.cus_id">
                  {{ c.cus_name }}
                </option>
              </select>

              <div *ngIf="errores.client_id" class="invalid-feedback">
                Debes seleccionar un cliente si el auspicio no es global.
              </div>

              <small *ngIf="nuevoTip.is_global" class="text-muted">
                Al ser global, no se asocia a un cliente específico.
              </small>
            </div>


          <hr class="estiloHrModal">
          <div class="container-fluid" style="padding: 10px 10px;align-items:center;text-align: center;">
            <button
              type="button"
              class="primary buttonStyleSecondary"
              (click)="saveTip()"
              [disabled]="isLoading"
            >
              <span *ngIf="!isLoading">Guardar</span>
              <span *ngIf="isLoading">Guardando...</span>
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading && modalActivo === 'crear'" class="overlay-modal">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>

</div>
<!-- modal Guardar-->